import { createContext } from 'react';

export type CursorState = 'default' | 'hovering' | 'text' | 'hidden';

export interface CursorContextType {
  cursorState: CursorState;
  cursorText: string;
  setCursorState: (state: CursorState) => void;
  setCursorText: (text: string) => void;
}

export const CursorContext = createContext<CursorContextType | null>(null);
